import { styled } from '@mui/material';
import { LegacyRef, createElement } from 'react';
import { forwardRef } from 'react';

type FilterCollectionProps = {
  onSelect?: (filter: string, useAsFilter: boolean) => any;
  filter?: string | undefined;
  customFilter?: string;
  filterColumn?: string;
};

interface FilterPanelProps {
  filterCollection?: React.FC<FilterCollectionProps>;
  onFilterItemSelected?: (filter: string, useAsFilter: boolean) => any;
  filterDateRange?: string | undefined;
  customFilter?: string;
  filterColumn?: string;
}

const Panel = styled('div')(({ theme }) => ({
  minHeight: '80px',
  height: 'auto',
  margin: '0px',
  boxShadow: 'none',
  borderRadius: '0px',
  padding: '0px',
  overflowX: 'hidden',
  overflowY: 'visible',
  backgroundColor: theme.palette.background.default
}));

const FilterPanel = (
  { filterCollection, onFilterItemSelected, filterDateRange, customFilter, filterColumn }: FilterPanelProps,
  ref: LegacyRef<HTMLDivElement> | undefined
) => {
  if (!filterCollection) return null;

  return (
    <Panel ref={ref}>
      {createElement(filterCollection, {
        onSelect: onFilterItemSelected,
        filter: filterDateRange,
        customFilter: customFilter,
        filterColumn: filterColumn
      })}
    </Panel>
  );
};

export default forwardRef(FilterPanel);
